import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import Home from "./components/Home";
import Admin from "./components/Admin";
import Login from "./components/Login";
import Root from "./components/Root";
import AccessCardSubmitted from "./components/AccessCardSubmitted";
import AccessLevelSubmitted from "./components/AccessLevelSubmitted";
import "bootstrap/dist/css/bootstrap.css";
import { Provider } from "react-redux";
import store from "./configureStore";
import withAuthorization from "./components/withAuthorization";

class App extends Component {
  render() {
    return (
      <div className="container">
        <Provider store={store}>
          <Router>
            <React.Fragment>
              <Switch>
                <Route
                  path="/access_card_submitted/"
                  component={AccessCardSubmitted}
                />
                <Route
                  path="/access_level_submitted/"
                  component={AccessLevelSubmitted}
                />

                <Route path="/admin" component={withAuthorization()(Admin)} />
                <Route path="/login" component={Login} />
                <Route path="/:token" component={Home} />
                <Route path="/" component={Root} exact />
              </Switch>
            </React.Fragment>
          </Router>
        </Provider>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js